







import { Component, Vue, Prop } from 'vue-property-decorator'
import PromotionGroupItem from './promotion_group_item.vue'
import PromotionSeckillItem from './promotion_seckill_item.vue'

@Component({
  components: { PromotionGroupItem, PromotionSeckillItem }
})
export default class PromotionTop extends Vue {
  @Prop({ default: 0 }) readonly serviceTime!: number
  @Prop({ default: () => {} }) readonly promotion!: any
}
